// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ParishCard_container__USf2l {
  background: white;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  transition-duration: 240ms;
  cursor: pointer;
  overflow: hidden;
}
.ParishCard_container__USf2l:hover {
  outline: 4px solid var(--primary);
}
.ParishCard_container__USf2l img {
  border: none;
}
.ParishCard_container__USf2l svg {
  color: var(--primary) !important;
}

.ParishCard_active__7O2Mj {
  outline: 1px solid var(--primary);
  background: #e0efea;
}
.ParishCard_active__7O2Mj svg {
  color: var(--primary-900) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ParishCard/ParishCard.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AACF;AAAE;EACE,iCAAA;AAEJ;AAAE;EACE,YAAA;AAEJ;AAAE;EACE,gCAAA;AAEJ;;AAEA;EACE,iCAAA;EACA,mBAAA;AACF;AAAE;EACE,oCAAA;AAEJ","sourcesContent":[".container {\n  background: white;\n  border-radius: 0.8rem;\n  display: flex;\n  align-items: center;\n  transition-duration: 240ms;\n  cursor: pointer;\n  overflow: hidden;\n  &:hover {\n    outline: 4px solid var(--primary);\n  }\n  img {\n    border: none;\n  }\n  svg {\n    color: var(--primary) !important;\n  }\n}\n\n.active {\n  outline: 1px solid var(--primary);\n  background: #e0efea;\n  svg {\n    color: var(--primary-900) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ParishCard_container__USf2l`,
	"active": `ParishCard_active__7O2Mj`
};
export default ___CSS_LOADER_EXPORT___;
